#import "@core/schema/fragments/CustomerFull.graphql"

mutation (
  $input: CustomerEditMeInput!
) {
  editMe(
    input: $input
  ) {
    ...CustomerFull
  }
}
